// extracted by mini-css-extract-plugin
export default {"wrapper":"ForgotModal_wrapper__JIiAB","content":"ForgotModal_content__vAh-1","recaptcha":"ForgotModal_recaptcha__GyKEu"};